import { render, staticRenderFns } from "./getTraceCode copy.vue?vue&type=template&id=da611c12&scoped=true"
import script from "./getTraceCode copy.vue?vue&type=script&lang=js"
export * from "./getTraceCode copy.vue?vue&type=script&lang=js"
import style0 from "./getTraceCode copy.vue?vue&type=style&index=0&id=da611c12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da611c12",
  null
  
)

export default component.exports